<template>
    <form 
        @submit.prevent="onSubmit"
        @reset.prevent="onReset"
    >
        <slot />
    </form>
</template>

<script>
// Vuex Store
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'FormWrapperLayout',
    computed: {
        ...mapState([
            'scrollOnCalculateInstance',
            'scrollOnCalculateEventName'
        ]),
        ...mapGetters([
            'editableEqualToSubmitted',
            'defaultEqualToSubmitted'
        ]),
    },
    methods: {
        ...mapActions([
            'setSubmittedFormValues',
            'initFormLoadingIndicator',
            'resetForm',
            'resetEditableFormFields',
            'resetFormFieldsValidity'
        ]),
        onSubmit: function() {
            if (!this.editableEqualToSubmitted) {
                this.initFormLoadingIndicator(this.setSubmittedFormValues)
                    .then(() => {
                        this.$emit('submitted');
                        this.emitScrollCustomEvent();
                    });
            }
        },
        onReset: function() {
            if (!this.editableEqualToSubmitted) {
                this.resetEditableFormFields();
                this.resetFormFieldsValidity();
            }
            else if (!this.defaultEqualToSubmitted) {
                this.initFormLoadingIndicator(this.resetForm)
                    .then(() => {
                        this.$emit('resetted');
                        this.emitScrollCustomEvent();
                    });
            }
        },
        emitScrollCustomEvent: function () {
            this.scrollOnCalculateInstance.$emit(
                this.scrollOnCalculateEventName
            );
        }
    }
};
</script>
